import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import { Button, Text } from '@lmc/ui-kit/src/general'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type PatternSelectEmptyStateProps = {
  link: string
}

const PatternSelectEmptyState = ({ link }: PatternSelectEmptyStateProps) => {
  const { t } = useTranslation()

  return (
    <EmptyState
      title={
        <EmptyStateWrapper>
          <Text>{t('SELECT_EMPTY_STATE_TYPES')}</Text>
        </EmptyStateWrapper>
      }
      description={
        <Link to={link} target="_blank" rel="noreferrer">
          <Button variant="primary">{t('EDIT')}</Button>
        </Link>
      }
      icon={
        <NoDataIconWrapper>
          <NoDataIcon />
        </NoDataIconWrapper>
      }
    />
  )
}

const NoDataIconWrapper = styled.div`
  scale: 0.5;
  height: 50px;
  display: flex;
  align-items: center;
`

const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export default PatternSelectEmptyState 